import { PaymentVariants } from "../types/constants";
import { ChangeSlider } from "../types/enums";
export function filterTariffs(tariffs, _a) {
    var period = _a.period, sum = _a.sum, changeSlider = _a.changeSlider, custom = _a.custom, variant = _a.variant;
    return tariffs.filter(function (tariff) {
        // Проверка по периоду
        var periodMatch = period.value === 0 || tariff.periods.includes(period.value);
        // Проверка по сумме
        var sumMatch = sum === 0 || (sum >= tariff.minSum && sum <= tariff.maxSum);
        // Проверка по варианту
        var variantMatch = variant === null ||
            (variant === PaymentVariants.MAIN_DEBT_AT_END
                ? tariff.mainDebtAtEndTerm === 1
                : tariff.mainDebtAtEndTerm === 0);
        // Проверка по кастомным фильтрам
        var customMatch = true; // По умолчанию всё подходит
        if (custom && custom.length > 0) {
            customMatch = custom.every(function (_a) {
                var key = _a.key, condition = _a.condition;
                // Проверяем каждый кастомный фильтр
                if (tariff[key] !== undefined) {
                    return condition(tariff[key]);
                }
                return true; // Если параметр не существует в объекте, пропускаем
            });
        }
        // Логика для разных типов фильтров (по периодам, суммам, perVip и кастомному фильтру)
        switch (changeSlider) {
            case ChangeSlider.PERIOD:
                return periodMatch && customMatch && variantMatch;
            case ChangeSlider.SUM:
                return sumMatch && customMatch && variantMatch;
            case ChangeSlider.CUSTOM:
                return customMatch && variantMatch;
            default:
                // Фильтрация по всем параметрам
                return periodMatch && sumMatch && variantMatch && customMatch;
        }
    });
}
